import React from 'react';
import { IconArrowBarToLeft } from '@tabler/icons-react';
import TooltipV2 from '@/components/TooltipV2';
import { HOOK_BUTTON_WIDTH_IN_PX } from '@/components/molecules/Transcript/constants';

export default function CreateHookButton({
  isVisible,
  left,
  top,
  onCreate
}: {
  isVisible: boolean;
  left: string;
  top: string;
  onCreate: () => void;
}) {
  if (!isVisible) {
    return null;
  }

  return (
    <div
      className="pointer-events-auto absolute z-[100] cursor-pointer"
      style={{ left, top }}
      onMouseEnter={e => e.stopPropagation()}
      onMouseLeave={e => e.stopPropagation()}
      onMouseOver={e => e.stopPropagation()}
    >
      <TooltipV2
        tooltipId="add-as-hook"
        tooltipContent="Add as hook"
        noArrow
        place="top"
        positionStrategy="fixed"
        className="z-[101]"
        tooltipElement={
          <button
            className="flex h-7 items-center justify-center rounded bg-black"
            style={{
              width: `${HOOK_BUTTON_WIDTH_IN_PX}px`
            }}
            onClick={e => {
              e.stopPropagation();
              onCreate();
            }}
            onMouseDown={e => {
              e.stopPropagation();
            }}
            aria-label="Add as hook"
          >
            <IconArrowBarToLeft size={14} className="text-white" />
          </button>
        }
      />
    </div>
  );
}
